import React from 'react';
import * as mobxReact from 'mobx-react';
import { injectIntl, IntlShape, FormattedMessage } from 'react-intl';
import { action } from 'mobx';
import { CommonPopupBodyFooterLayout } from '../../../../global/common-popup/common-popup-body-footer-layout';
import DefaultButton from '../../../../global/default-button/default-button';
import { FormField } from '../../../../global/form/form-field/form-field';
import { RichTextEditor } from '../../../../global/rich-text-editor';
import { EmailVariablesSection } from '../../../../global/email-variables/email-variables';
import { EMAIL_LIST_TYPE } from '../../../../../constants/email-variables.constants';
import { ConfigureOrderBookingEmailVM } from './order-booking-emails-list.viewmodel';
import {
    APPLY_TEXT,
    CANCEL_TEXT,
    EMAIL_BODY_LABEL,
    EMAIL_SUBJECT_LABEL,
} from './order-booking-emails.texts';

interface IProps {
    vm: ConfigureOrderBookingEmailVM;
    intl: IntlShape;
}

export const ConfigureOrderBookingEmailPresentation = injectIntl(mobxReact.observer((props: IProps) => {
    const { vm, intl } = props;

    return (
        <CommonPopupBodyFooterLayout
            className='oe-form emails-template-form'
            body={
                <div className='emails-template-form__content'>
                    <EmailVariablesSection type={EMAIL_LIST_TYPE.ORDER_BOOKING} />
                    <FormField
                        className='m-top-5px'
                        label={<FormattedMessage {...EMAIL_SUBJECT_LABEL} />}
                        labelFor='order-booking-email-subject'
                    >
                        <input
                            id='order-booking-email-subject'
                            className='oe-form-field__control'
                            value={vm.subject}
                            onChange={e => vm.setSubject(e.target.value)}
                            type='text'
                        />
                        {!!vm.subjectError && <span className='oe-form-field__error'>{vm.subjectError}</span>}
                    </FormField>
                    <FormField
                        label={<FormattedMessage {...EMAIL_BODY_LABEL} />}
                        className='with-editor'
                    >
                        <RichTextEditor
                            className='m-top-0px body-editor'
                            value={vm.body}
                            onChange={action((event, editor) => {
                                vm.setBody(editor.getData());
                            })}
                            validationError={vm.bodyError || null}
                        />
                    </FormField>
                </div>
            }
            footer={
                <div className='buttons-block buttons-block--from-right'>
                    <DefaultButton
                        modifier={['fat', 'confirm-safe']}
                        text={intl.formatMessage(APPLY_TEXT)}
                        onClick={vm.apply}
                        disabled={vm.saving}
                    />
                    <DefaultButton
                        modifier={['fat']}
                        text={intl.formatMessage(CANCEL_TEXT)}
                        onClick={vm.cancel}
                        disabled={vm.saving}
                    />
                </div>
            }
        />
    );
}));
